// Import model
import { DataviewAiChatResponse } from '../models/DataviewAiChatResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { AiChat } from '../models/AiChat';
import { DataView } from '../models/DataView';
import { FilterAiChatRequest } from '../models/FilterAiChatRequest';

// Import dependency serializers (for complex types)
import { AiChatSerializer } from './AiChatSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterAiChatRequestSerializer } from './FilterAiChatRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewAiChatResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewAiChatResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewAiChatResponse instance
   */
  static deserialize(json: string): DataviewAiChatResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewAiChatResponse instance
   */
  static fromObject(obj: any): DataviewAiChatResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewAiChatResponse');
    }


    const instance: DataviewAiChatResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        AiChatSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterAiChatRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewAiChatResponse instances
   */
  static deserializeArray(json: string): DataviewAiChatResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewAiChatResponse instance to a JSON string
   */
  static serialize(instance: DataviewAiChatResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewAiChatResponse instance to a plain object
   */
  static toObject(instance: DataviewAiChatResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        AiChatSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterAiChatRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewAiChatResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewAiChatResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
